/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const aino = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M6.84 12.594c-1.067-.603-1.837-1.18-2.601-1.77-.437 1.268-.823 2.524-1.002 3.266l-1.206.001c.233-.984.746-2.574 1.27-3.993C1.969 9.012.508 7.3 1.162 6.265c.384-.608 1.297-.953 3.758-.167C6.87 1.819 7.722 1.008 8.613 1c1.013-.01 1.943.991 4.002 5.733 1.158 2.665 2.845 6.676 2.268 7.708-.886 1.582-5.78-.567-8.043-1.847Zm-2.188-2.89c.752.605 1.532 1.158 2.734 1.878 1.38.827 6.214 2.968 6.56 2.3.415-.838-3.659-3.733-5.215-4.658-1.348-.801-2.239-1.286-3.211-1.68a77.281 77.281 0 0 0-.868 2.16Zm1.293-3.198c1.708.707 5.956 3.29 7.56 4.957a129.35 129.35 0 0 0-2.006-4.719c-1.047-2.32-2.158-4.64-2.886-4.636-.578 0-1.384 1.375-2.668 4.398Zm-3.848.32c-.328.459.94 1.553 1.63 2.14.164-.41.57-1.423.741-1.825-.906-.368-2.145-.708-2.371-.316Z"
    />
  </svg>
)
export default aino
